/* 5xx errors, failed connection or timeout */
const errorMapping = {
    "The operation was aborted. ": "El tiempo de respuesta para la conexión ha expirado",
    "500": "Se ha producido un error de conexión, inténtalo de nuevo.",
}

export const errorMapper = (key) => {
    const { code = 'Se ha producido un error inesperado'} = { code: errorMapping[key] }

    return code;
}

const warningMapping = {
    "database_error": "Se ha producido un error con la base de datos.",
    "bad_request": "La solicitud no se ha podido procesar.",
    "not_found": "No se ha encontrado el contenido.",
    "forbidden": "No tienes permisos para realizar esta acción.",
    "invalid_token": "El enlace de activación o recuperación no es válido o ha expirado.",
    "activation_error": "No se pudo activar el usuario.",
    "restore_error": "No se pudo restaurar la contraseña.",
    "user_not_activated": "El usuario todavía no ha sido activado correctamente.",
    "user_not_found": "El usuario no ha sido encontrado.",
    "wrong_password": "La contraseña introducida no es correcta.",
    "wrong_orchestra": "La orquesta seleccionada es incorrecta.",
    "validation_error": "Los datos enviados no son válidos.",
}

export const warningMapper = (key) => {
    const { code = 'Se ha producido un error inesperado'} = { code: warningMapping[key] }

    return code;
}